import React from 'react';
import moment from 'moment';
import styled from 'styled-components/macro';
import BusinessIcon from '@mui/icons-material/Business';
import RoomIcon from '@mui/icons-material/Room';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PersonIcon from '@mui/icons-material/Person';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

import ScheduleAppointmentModal from 'components/general/SchduleAppointmentModal';
import { FlexCenterVertical } from 'styles/flexbox';
import { border } from 'variables/general';
import { black, grey70 } from 'variables/colors';
import { formatPhoneNumber } from 'helpers/format-phone-number';
import { deleteAppointment } from 'api/appointment';
import { siteNameGenerator } from 'helpers/site-name-generator';

const DetailsWrapper = styled.div`
  padding: 2em 1.5em 0;
  color: ${grey70};
`;

const Details = styled.div`
  display: grid;
  grid-gap: 1.5em;
  grid-template-rows: ${({ count }) => Array(count).fill('1fr').join(' ')};

  margin-top: 2em;

  &:not(:last-of-type) {
    margin-bottom: 2em;
    padding-bottom: 2em;
    border-bottom: ${border};
  }
`;

const SubHeading = styled.h3`
  color: ${black};
`;

const Detail = styled(FlexCenterVertical)``;

const Label = styled.h5`
  margin-left: 0.875em;
`;

const CancelBooking = ({ logo, setStep, appointment, linkId }) => {
  const {
    start_date: startDate,
    end_date: endDate,
    relationShips: { service, clinic, participant, organization, sublocation },
  } = appointment || {};

  const clinicDetails = [
    {
      label: organization[0].name,
      icon: <BusinessIcon />,
    },
    {
      label: siteNameGenerator(organization[0], sublocation[0]),
      icon: <RoomIcon />,
    },
    {
      label: service[0].name,
      icon: <HealthAndSafetyOutlinedIcon />,
    },
    {
      label: `${clinic[0].service_duration} minutes`,
      icon: <AccessTimeIcon />,
    },
    {
      label:
        moment(startDate, 'YYYY-MM-DD HH:mm:ss').format('h:mm') +
        moment(endDate, 'YYYY-MM-DD HH:mm:ss').format(' - h:mma') +
        moment(endDate, 'YYYY-MM-DD HH:mm:ss').format(', dddd, MMMM DD, YYYY'),
      icon: <CalendarTodayIcon />,
    },
  ];

  const userDetails = [
    {
      label: `${participant[0].first_name} ${participant[0].last_name}`,
      icon: <PersonIcon />,
    },
    {
      label: participant[0].email,
      icon: <MailOutlineIcon />,
    },
    ...(participant[0].phone
      ? [
          {
            label: formatPhoneNumber(participant[0].phone),
            icon: <LocalPhoneOutlinedIcon />,
          },
        ]
      : []),
  ];

  const handleCancelAppointment = async () => {
    try {
      await deleteAppointment(linkId);
      setStep('cancel-confirm');
    } catch (error) {
      console.error(error);
      setStep('error');
    }
  };

  return (
    <ScheduleAppointmentModal
      logo={logo}
      buttonText="Cancel Appointment"
      handleNext={handleCancelAppointment}
      maxWidth="30em"
      maxHeight="50em"
      cancel
    >
      <DetailsWrapper>
        <SubHeading>Details</SubHeading>
        <Details>
          {clinicDetails.map(({ label, icon }) => (
            <Detail>
              {icon}
              <Label>{label}</Label>
            </Detail>
          ))}
        </Details>

        <SubHeading>Your Info</SubHeading>
        <Details count={clinicDetails.count}>
          {userDetails.map(({ label, icon }) => (
            <Detail>
              {icon}
              <Label>{label}</Label>
            </Detail>
          ))}
        </Details>
      </DetailsWrapper>
    </ScheduleAppointmentModal>
  );
};

export default CancelBooking;
